import React, { useMemo } from 'react';

import { Box, BoxProps } from '@mui/system';
import { addSize } from '@scorenco/core';

export const Image = React.forwardRef(
  (
    {
      component = 'img',
      src,
      alt = '',
      loading = 'lazy',
      width,
      height,
      ...rest
    }: ImageProps,
    ref
  ) => {
    const imageUrl = useMemo(
      () =>
        addSize(
          typeof src === 'string' ? src : undefined,
          typeof width === 'number' ? width : undefined,
          typeof height === 'number' ? height : undefined
        ),
      [width, height, src]
    );

    return (
      <Box
        component={component}
        src={imageUrl}
        alt={alt}
        loading={loading}
        ref={ref}
        {...rest}
      />
    );
  }
);

export type ImageProps = React.JSX.IntrinsicElements['img'] & BoxProps;
